import defineComponent from 'flight';

function PaymentOptionsUI() {
    this.defaultAttrs({
        markAsPaid: '[data-checkout-mark-as-paid]',
        paymentOptionLink: '[data-checkout-payment-option]',
        fakePayButton: '[data-checkout-pay-disabled]'
    });

    this._disablePaymentButtons = function () {
        this.select('paymentOptionLink').addClass('hidden');
        this.select('markAsPaid').attr('disabled', 'disabled');
        this.select('fakePayButton').removeClass('hidden');

    };

    this.after('initialize', function () {
        this.on(document, 'ui:checkout:on-shipping-option-change', this._disablePaymentButtons);
    });
}

module.exports = defineComponent.component(PaymentOptionsUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout/payment-options-ui.js